<template>
  <div style="width: 1200px; margin: 0 auto">
    <div style="z-index: -1;">
      <!--head-->
      <div class="selectedTitle">
        <router-link :to="{ name:'JewelleryHome' }">
          <span style="padding-left: 10px">{{ $t('mall_home.jewellery_box') }}<!-- 搜飾盒 --></span>
        </router-link>

        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <router-link :to="{ name:'Search', query: { type: 'RECO' } }"><span>
          {{ $t('mall_home.fine_jewellery') }}<!-- 珠寶首飾 -->
        </span></router-link>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <router-link :to="{ name:'Search', query: { type: 'RG' } }">
          <span>{{ product.product_type_code | TypeName(i18Filter) }}</span></router-link>
        <img :src="require('@/assets/homeImg/ssjg_mbx_jt@2x.png')" alt="">
        <span class="selectItem">{{ product.default_name }}</span>
      </div>
      <div class="divider"></div>
      <div class="productBox clearFix">
        <div class="leftBox" @mouseenter="showBig">
          <vue-magnify
            @move="handleMove"
            :previewImg="modelPath.min"
            :zoomImg="modelPath.max">
          </vue-magnify>
          <div class="productImgShow" style="overflow:hidden;">
            <div v-for="(item,index) in modelPathList"
                 :key="index"
                 @mouseenter="changeImage(index)" class="smallImg"
                 ref="smallImg"
                 @click="smallImgChoose(index)">
              <img :src="item.min" alt="">
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div>
            <div class="header displayR">
              <span style="max-width: 300px; overflow: hidden;">{{ product.default_name }}</span>

              <!--              <img :src="require('@/assets/homeImg/spxq_icon_bq@2x.png')" alt="">-->
              <span v-show="product.is_new" class="is_new">
                      {{ $t('mall_search.new') }}<!-- 新品 -->
                    </span>
              <!--<img class="collectionIcon" :src="require('@/assets/homeImg/spxq_icon_aixin@2x.png')" alt="">-->
            </div>
            <div class="rightPrice">${{ product.areas[0].price | PriceFormat }}</div>
            <div class="line"></div>
            <div style="padding: 10px 15px 20px 15px;background-color: #FCFBF9;margin-top: 15px;">
              <div>
                <div class="displayR" style="align-items: center;margin-top: 15px;">
                  <div style="margin-right: 20px;">
                    {{ $t('mall_detail.color') }}<!-- 顏色 -->
                  </div>
                  <div v-for="(item,index) in product.color_photo" @click="chooseMt(item.product_color_id,index)"
                       :key="index"
                       ref="material"
                       class="material"
                       :class="{ 'active': index === 0 }"
                       v-model="choose">
                    <img :src="imgUrl + item.path + '?x-oss-process=image/resize,m_fill,h_65,w_65'" alt="">
                    <img class="arrow" ref="arrow" :src="require('@/assets/homeImg/ssjg_icon_xuanzhong@2x.png')" alt=""
                         :style="{display: index === 0 ? 'block' : 'none'}">
                  </div>
                </div>
                <div class="displayR sizeBox">
                  <span>
                   {{ $t('mall_detail.size') }} <!-- 尺寸 -->
                  </span>
                  <div class="chooseSize">
                    <el-select v-model="currentProduct.product_size"
                               :placeholder="$t('mall_detail.choose_size')"
                               size="small"
                               style="width: 134px;margin-left: 20px;margin-right: 20px;">
                      <el-option
                        v-for="item in size[product.product_type_code.toLowerCase()]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                      <el-option
                        v-show="!size[product.product_type_code.toLowerCase()]" :label="size.default" value="">
                      </el-option>
                    </el-select>
                    <!--                    <el-input-number size="small"-->
                    <!--                                     style="width: 120px;"-->
                    <!--                                     v-model="num"-->
                    <!--                                     @change="handleChange"-->
                    <!--                                     :min="1"-->
                    <!--                                     :max="1"-->
                    <!--                                     label="描述文字"></el-input-number>-->
                  </div>
                </div>
                <div class="parameter">
                  {{ $t('mall_detail.params') }}<!-- 商品參數 -->
                </div>
                <div class="line"></div>
                <div>
                  <div v-for="(item,index) in product.params" :key="index" class="parameterItem">
                    <span class="parameterName">{{ item.param_key }}</span>
                    <span>{{ item.value }}</span>
                    <span></span>
                  </div>
                </div>
                <div class="btns displayR">
                  <!--                  <div class="addCart" @click="dialogVisible = true">加入購物袋</div>-->
                  <div class="addCart" @click="addCart">
                    {{ $t('mall_detail.add_cart') }}<!-- 加入購物袋 -->
                  </div>
                  <div class="shopNow" @click="buyNow">
                    {{ $t('mall_detail.to_buy') }}<!-- 立即購買 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collocation">
        <div id="product_box" class="h-fullscreen product_box goCenter">
          <div class="text-center" style="padding: 50px 110px;background-color: #F5F1ED;">
            <div class="row align-items-center">
              <div class="collocationHead">JEWELLERY-BOX · {{ $t('mall_detail.you_like') }}</div>
              <!--產品展示列表-->
              <div class="product-list" ref="productList">
                <ul class="show-list" ref="showList">
                  <li class="item" ref="itemProduct" v-for="(item,index) in product.collocation.data" :key="index">
                    <div class="li_box">
                      <router-link :to="{name:'Product', query:{id:item.product_model_id}}">
                        <img :src="imgUrl + item.product_model.path + '?x-oss-process=image/resize,m_fill,h_430,w_430'"
                             alt="">
                      </router-link>
                      <p style="color: #222;">{{ item.product_model.default_name }}</p>
                      <p style="color: #222;margin-top: 5px;margin-bottom: 0;">${{ item.price | PriceFormat }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <span class="pre" @click="pre">
            <img :class="{ 'rotate': curr > 0 }"
                 :src="curr <= 0 ? require('@/assets/homeImg/spxq_tjdp_icon_jtbke@2x.png') : require('@/assets/homeImg/ssjg_tjdp_icon_jtkexuan@2x.png')">
          </span>
          <span class="next" @click="next">
            <img :class="{ 'rotate': curr >= product.collocation.to - 3 }"
                 :src="curr === product.collocation.to - 3 ? require('@/assets/homeImg/spxq_tjdp_icon_jtbke@2x.png') : require('@/assets/homeImg/ssjg_tjdp_icon_jtkexuan@2x.png')">
          </span>
        </div>
      </div>
    </div>
    <div class="showMask">
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        :before-close="handleClose">
        <!--<div class="mask">-->
        <div class="cartItems">
          <div class="close pointer" @click="dialogVisible = false"><img
            :src="require('@/assets/homeImg/wdgwd_icon_close@2x.png')" alt=""></div>
          <div class="allBox">
            <div class="shopBag">
              <span>{{ $t('mall_detail.my_cart') }}<!-- 我的購物袋 --></span>
              <span class="sum">
                {{ $t('mall_detail.have') }}
                {{ goods.length }}
                {{ $t('mall_detail.items') }}</span>
            </div>
            <div>
              <transition-group name="fade" tag="ul">
                <li class="maskBox" v-for="item in goods" :key="item.id">
                  <div class="maskLeft">
                    <div class="imgBox">
                      <router-link :to="{name:'Product', query:{id:item.product_model_id}}">
                        <img :src="imgUrl + item.product_model.color_photo[0].path" alt="">
                      </router-link>
                    </div>
                  </div>
                  <div class="maskRight">
                    <div>
                      <div class="left">
                        <div class="name">{{ item.product_model.default_name }}</div>
                        <div class="color"><span class="title">
                          {{ $t('mall_detail.color') }} : <!-- 顏色 -->
                        </span> <span>{{ item.product_model.color_photo[0].color.name }}</span></div>
                        <div class="size">
                          <span class="title">
                            {{ $t('mall_detail.size') }} : <!-- 尺寸 -->
                          </span>
                          <span>
                            {{
                              item.product_size === 0 ? $t('mall_detail.free_size') : item.product_size + $t('mall_detail.free_num')
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="right">
                        <img class="remove" :src="require('@/assets/homeImg/wdgwd_icon_close@2x.png')" alt=""
                             @click="remove(item.id)">
                        <div class="price">${{ item.product_model.areas[0].price|PriceFormat }}</div>
                      </div>
                    </div>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>

        </div>
        <div class="settlementBox pointer" @click="buyCart">
          <div class="toSum">
            {{ $t('mall_detail.total') }}<!-- 總計 -->
            : ${{ getSun()| PriceFormat }}
          </div>
          <div class="settlement">
            {{ $t('mall_detail.checkout') }} <!-- 結算購物車 -->
          </div>
          <!--            <div class="settlementBox">-->
          <!--              <div class="settlement" @click="buyCart">結算</div>-->
          <!--            </div>-->
        </div>

        <!--</div>-->
        <span slot="footer" class="dialog-footer">
  </span>
      </el-dialog>
    </div>
    <div style="margin-bottom: 60px"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import PriceFormat from '@/assets/js/PriceFormat';
import baseUrl from '@/api/baseUrl.js'
import vueMagnify from 'vue-magnify';

Vue.use(vueMagnify);
let speed = 5;
export default {
  name: "Product",
  components: {},
  data() {
    return {
      imgUrl: baseUrl.imgUrl,
      num: 1,
      cartNum: 1,
      size: {
        default: '',
        rg: [
          {value: 10, label: '10'},
          {value: 11, label: '11'},
          {value: 12, label: '12'},
          {value: 13, label: '13'},
          {value: 14, label: '14'},
          {value: 15, label: '15'},
          {value: 16, label: '16'},
        ],
      },
      color_id: 0,
      value: '',
      isShow: false,
      choose: false,
      index: 0,
      flag: false,
      offset: 0,
      timer: null,
      curr: 0,
      playStatus: '',
      muteStatus: '',
      isMute: true,
      isPlay: false,
      area: 440300,
      hotTop: 0,
      modelPath: {
        min: '',
        max: '',
      },
      modelPathList: [],
      drawer: false,
      direction: 'rtl',
      dialogVisible: false,
      goods: [],
      show: true,
      product: {
        id: '',
        default_name: '',
        product_type_code: '',
        areas: [
          {
            price: 0,
          }
        ],
        collocation: {
          data: null,
        }
      },
      currentProduct: {
        product_model_id: '',
        product_color_id: '',
        product_size: '',
      },
      Totals: 0,
    }
  },
  filters: {
    PriceFormat(val) {
      return PriceFormat(val);
    },
    TypeName(typeCode, i18Filter) {
      //这里 this.$t为定义，只能通过method转换下
      return i18Filter(typeCode);
    }
  },
  methods: {
    i18Filter(typeCode) {
      // switch (typeCode) {
      //   default:
      //     return '綜合篩選';
      //   case 'RG':
      //     return '戒指';
      //   case 'BG':
      //     return '手鐲';
      //   case 'ER':
      //     return '耳環';
      //   case 'BL':
      //     return '手鏈';
      //   case 'PD':
      //     return '吊墜';
      //   case 'NL':
      //     return '項鏈';
      //   case 'CL':
      //     return '袖口鈕';
      // }
      return this.$t('mall_home.' + typeCode.toLowerCase())
    },
    buyCart() {
      if (this.goods.length === 0) {
        this.$notify.info({
          message: this.$t('mall_detail.cart_empty')//'當前購物車為空'
        });
      } else {
        let orderData = [];
        this.goods.forEach(row => {
          orderData.push({
            'product_model_id': row.product_model_id,
            'product_color_id': row.color_id,
            'product_size': row.product_size
          })
        });
        this.$router.push({
          name: 'ConfirmOrder',
          query: {products: JSON.stringify(orderData)}
        });
      }
    },
    buyNow() {
      if (this.toValidator()) {
        this.currentProduct.product_model_id = this.product.id;
        this.$router.push({
          name: 'ConfirmOrder',
          query: {products: JSON.stringify([this.currentProduct])}
        });
      }
    },
    getCart() {
      this.$axios.get('api/app_v1/customer/shopping_cart_itemsV2', {}).then(res => {
        this.goods = res.data.data;
        this.dialogVisible = true;
      })
    },
    toValidator() {
      if (!this.currentProduct.product_color_id) {
        this.$notify.error({
          message: this.$t('mall_detail.select_color')//"未選擇顏色"
        })
        return false;
      }
      if (!this.size.default && !this.currentProduct.product_size) {
        this.$notify.error({
          message: this.$t('mall_detail.select_size')//"未選擇尺寸"
        })
        return false;
      }
      return true
    },
    addCart() {
      if (this.toValidator()) {
        this.$axios.post('api/app_v1/customer/shopping_cart_itemsV2',this.currentProduct).then(res => {
          this.$notify.success({
            title: this.$t('mall_detail.success_add') //'添加成功'
          });
          this.getCart();
          //父頁面購物車刷新
          this.$emit('refreshCart');
        }).catch(err => {
          let that = this;
          if (!(err.error && err.error.code && err.error.code === '10001')) {
            setTimeout(function () {
              that.getCart()
            }, 400);
          }
        });
      }
    },
    showBig() {

    },
    handleMove() {

    },
    handleClose(done) {
      done();
    },
    handleAddCart(value) {
      console.log(value);
    },
    //放大鏡
    changeImage: function (index) {
      this.modelPath = this.modelPathList[index];
    },
    //購買數量選擇
    handleChange(value) {
    },
    chooseMt(color_id, index) {
      this.currentProduct.product_color_id = color_id;
      let that = this;
      let mater = document.getElementsByClassName('material');

      that.$refs.arrow.forEach((item, indexItem) => {
        if (index === indexItem) {
          that.choose = true;
          mater[indexItem].className = ' material active';
        } else {
          that.choose = false;
          mater[indexItem].className = ' material';
        }
      });
      this.$refs.arrow.forEach((item, indexItem) => {
        if (index === indexItem) {
          item.style.display = 'block';

        } else {
          item.style.display = 'none';
        }
      })
    },
    smallImgChoose(index) {
      let that = this;
      this.$refs.smallImg.forEach((item, indexItem) => {
        if (index === indexItem) {
          that.choose = true;
        } else {
          that.choose = false;
        }
      });
    },
    //上壹張
    pre() {
      var that = this;
      var scrollLeft = that.$refs.itemProduct[0].clientWidth
      if (!that.flag) {
        that.flag = true;
        // 切換圖片
        // 1.清空定時器
        clearInterval(that.timer)
        this.curr--;
        if (that.curr < 0) {
          that.curr = 0;
          that.$refs.showList.style.left = that.curr * scrollLeft + 'px'
        }
        this.timer = setInterval(function () {
          that.offset += speed
          if (that.offset >= -that.curr * scrollLeft) {
            clearInterval(that.timer)
            that.offset = -that.curr * scrollLeft
            that.flag = false
          }
          that.$refs.showList.style.left = that.offset + 'px'
        }, 10)
      }
    },
    //下壹張
    next() {
      var that = this;
      var scrollLeft = that.$refs.itemProduct[0].clientWidth
      if (!that.flag) {
        that.flag = true;
        // 切換圖片
        // 1.清空定時器
        clearInterval(that.timer);
        this.curr++;
        if (that.curr > that.$refs.itemProduct.length - 3) {
          that.curr = that.$refs.itemProduct.length - 3
          that.$refs.showList.style.left = that.curr * scrollLeft + 'px';
        }
        this.timer = setInterval(() => {
          that.offset -= speed;
          if (that.offset <= -that.curr * scrollLeft) {
            clearInterval(that.timer);
            that.offset = -that.curr * scrollLeft;
            that.flag = false;
          }
          that.$refs.showList.style.left = that.offset + "px";
        }, 10)
      }
    },
    //移除商品
    remove(id) {
      console.log("ffefdf", id)
      this.$axios.delete("api/app_v1/customer/shopping_cart_items/" + id, {}).then(res => {
        this.$notify.success({
          message:this.$t('mall_cart.success_delete')// '刪除成功'
        });
        this.getCart();
        this.$emit('refreshCart');
      });
    },
    getProductDetail(id) {
      this.$axios.get('api/app_v1/for_ssh/product_model_detail/' + id, {}).then(res => {
        this.product = res.data.data;
        this.product.photos.map(res => {
          this.modelPathList.push({
            min: this.imgUrl + res.path + '?x-oss-process=image/resize,m_fill,h_430,w_430',
            max: this.imgUrl + res.path + '',
          });
        });
        this.size.default = this.size[this.product.product_type_code.toLowerCase()] ? '' : this.$t('mall_detail.free_size');
        this.currentProduct.product_model_id = this.product.id;
        this.currentProduct.product_color_id = this.product.color_photo[0].product_color_id;
        this.changeImage(0);
      });
    },
    //函數計算中的狀態改變後，函數會自動執行壹遍
    getSun() {
      var sun = 0;
      for (var i in this.goods) {
        sun += this.goods[i].product_model.areas[0].price
      }
      return sun
    },

  },
  mounted() {
  },
  created() {
    this.getProductDetail(this.$route.query.id);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    // this.getCart();
    console.log("fine_jewellery===--=created---=>", this.$t('mall_home.fine_jewellery'));

  },

}
</script>

<style lang="less" scoped>

.divider {
  padding: 0 100px;
  height: 1px;
  background-color: #ddd;
}

.productBox {
  margin: 30px 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.leftBox {
  width: 432px;
  float: left;
  padding: 0 30px;
  /*margin-right: 30px;*/
  /*border: 1px solid #ddd;*/
  position: relative;
}

.bigBox > img {
  width: 200%;
  height: 200%;
}

.productImg .magnifier-box > img {
  /*width: 60%;*/
}

.smallImg {
  width: 60px;
  height: 60px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  float: left;
  margin-right: 10px;
}

.smallImg:hover {
  -webkit-box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
  -moz-box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
  box-shadow: 0px 0px 5px 1px rgba(30, 19, 3, 0.13);
}

/*.smallImgActive {*/
/**/
/*}*/
.smallImg > img {
  max-width: 80%;
  max-height: 80%;
}

.rightBox {
  flex: 1;
  color: #7A7977;
  font-size: 14px;
  margin: 0 30px;
  /*float: left;*/
  /*border: 1px solid #ddd;*/
}

.header {
  font-size: 22px;
  color: #353433;
  margin-top: 20px;
  align-items: center;
  position: relative;
  align-items: center;
}

.collectionIcon {
  width: 18px !important;
  height: 15px !important;
  position: absolute;
  right: 10px;
}

.rightHead > span {
  color: #353433;
  font-size: 22px;
  margin-right: 10px;
}

.header > img {
  width: 57px;
  height: 24px;
  margin-left: 10px;
}

.rightPrice {
  color: #1E1303;
  font-size: 28px;
  padding-bottom: 10px;
}

.material {
  overflow: hidden;
  width: 63px;
  height: 63px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  float: left;
  margin-right: 10px;
  position: relative;
}

.material > img {
  /*width: 80%;*/
}

.arrow {
  position: absolute;
  bottom: -1px;
  right: 0;
  width: 22px !important;
  height: 23px;
  display: none;
}

.productBox .active {
  border: 1px solid #D7B189 !important;
}

.sizeBox {
  align-items: center;
  height: 34px;
  margin-top: 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

}

.line {
  width: 100%;
  height: 1px;
  margin: 10px 0 10px 0;
  background-color: #ddd;
}

.chooseSize select {
  /*width: 134px;*/
  /*height: 34px;*/
}

.parameter {
  margin-top: 30px;
}

.parameterItem {
  padding: 5px 0 5px 0;
  width: 100%;
  display: flex;
}

.parameterItem span {
  display: inline-block;
  flex: 1;
}

.parameterName {

}

.btns {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.btns div {
  padding: 12.5px 0;
}

.addCart {
  cursor: pointer;
  height: 100%;
  flex: 1;
  border: 1px solid #C0A876;
  color: #C0A876;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  margin-right: 20px;
}

.shopNow {
  color: #fff;
  cursor: pointer;
  flex: 1;
  background-color: #C0A876;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}


/*產品*/
.product_box {
  background-color: #fff;
  /*padding: 100px;*/
  position: relative;
}

.product-list {
  position: relative;
  width: 100%;
  height: 440px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #F5F1ED;

}

.show-list {
  top: 0;
  left: 0;
  width: 1000%;
  height: 100%;
  position: absolute;
}

.item {
  width: 330px;
  height: 420px;
  float: left;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;

  /*background-color: #fff;*/

}

.li_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  min-width: 192px;
  min-height: 192px;
  padding-bottom: 20px;
  width: 100%;
  background-color: #F5F1ED;
  border: 1px solid #868583;
  border-left: none;
}

.li_box a {
  border: none !important;
  font-size: 0;
  text-align: center;
  width: 260px;
  height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}

.li_box img {
  max-width: 100%;
  max-height: 100%;
}

.rotate {
  transform: rotateY(180deg);
}

.pre, .next {
  display: block;
  width: 40px;
  height: 40px;
  color: #000;
  padding: 30px 0;
  font-size: 40px;
  text-align: left;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  margin-bottom: 0;
  cursor: pointer;


}

.pre > img, .next > img {
  width: 100%;
  height: 100%;
  /*padding: 5px;*/
  /*background-color: #fff;*/
}

.pre {
  left: 10px;
}

.next {
  text-align: right;
  right: 10px;
}

.collocation {
  width: 1200px;
  margin-top: 100px;
}

.align-items-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.collocationHead {
  text-align: center;
  width: 80%;
  padding: 20px 0;
  color: #1E1303;
  font-size: 22px;

}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}

.allBox {
  padding-top: 80px;
}

.cartItems {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  color: #1E1303;
  overflow-y: hidden;
  z-index: 999;
  padding-bottom: 30px;
}

.close {
  width: 23px;
  position: absolute;
  right: 0;
}

.close:hover {
  opacity: 0.6;
}

.close > img {
  width: 100%;
}

.shopBag {
  font-size: 22px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.sum {
  color: #7A7977;
  font-size: 14px;
}


.maskBox {
  height: 210px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.maskLeft {
  box-sizing: border-box;
  width: 150px;
  /*padding-right: 10px;*/
}

.maskLeft .imgBox {
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  background-color: #fff;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.maskLeft .imgBox a {
  width: 100%;
  height: 100%;
}

.maskLeft .imgBox a img {
  width: 100%;
}

.maskRight {
  flex: 1;
  font-size: 14px;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  padding: 30px 0 30px 20px;
}

.maskRight > div {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

.maskRight .left {
  flex: 1;
  font-size: 14px;
}

.maskRight .left .title {
  color: #979694;
  margin-right: 5px;
}

.maskRight .left .name {
  font-size: 18px;
  padding: 8px 0 14px 0;
}

.maskRight .right {
  flex: 1;
  display: flex;
  align-content: center;
  align-items: center;
}

.maskRight .right .remove {
  display: block;
  right: 0;
  top: 0;
  position: absolute;
  width: 10px;
  height: 10px;
  float: right;
  cursor: pointer;
  padding: 5px;
}

.maskRight .right .price {
  font-size: 20px;
  width: 100%;
  text-align: right;
  padding: 5px 0 40px 0;
  font-family: STSong;
}

.settlementBox {
  display: flex;
  background: #1E1303;
  padding: 16px 0;
  margin: 20px 0;
}

.settlementBox .toSum {
  flex: 1;
  color: #ffffff;
  font-size: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding-left: 22px;
}

.settlementBox .settlement {
  width: 150px;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}

/**動畫初始和結束的時候*/
/*position: absolute;*/
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

/deep/ .leftBox .vue-magnify {

}

/deep/ .leftBox .vue-magnify .preview-box {
  display: flex;
  align-items: center;
  border: none !important;
}

/deep/ .leftBox .vue-magnify .preview-box > img {
}

/deep/ .el-select-dropdown__item {
  text-align: center;
}

/deep/ .vue-magnify .zoom-box {
  left: 490px;
  /*height: 450px;*/
  background-color: #fff;
  z-index: 999;
  border-color: #DDD !important;
}

/deep/ .vue-magnify .zoom-box > img {
  left: 450px;
  /*height: 450px;*/
  background-color: #fff;
  z-index: 99;
  border-color: #DDD !important;
}

/*showMask*/
/deep/ .showMask .el-dialog__headerbtn {
  font-size: 0;
}

/deep/ .showMask .el-dialog {
  width: 570px;
  min-height: 100%;
  margin-right: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0;
}

/deep/ .showMask .el-dialog__header {
  padding: 0 !important;
  display: none !important;
}

/deep/ .showMask .el-dialog__footer {
  display: none;
}

/deep/ .showMask .el-dialog__body {
  /*display: none;*/
  padding: 30px 50px;
}

.is_new {
  opacity: 0.8;
  cursor: default;
  /*position: absolute;*/
  text-align: center;
  font-size: 14px;
  margin-left: 10px;
  padding: 1px 10px;
  color: #d0b377;
  /* width: 57px;*/
  font-weight: 900;
  border: 2px solid #d0b377;
}
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Product.vue